class Selection {
    constructor(product, form) {
        this.product = product;
        this.form = form;
    }

    get options() {
        return this.product.options.reduce((carry, option) => {

            const formOptions = this.form.options();
            const foundOption = formOptions.find(({ name }) => name === option.name);
            if (!foundOption) {
                return carry;
            }
            const { value } = foundOption;
            return { ...carry, [option.name]: value };
        }, {});
    }

    index(index) {
        const options = this.options;
        const optionValue = Object.values(options)[index];
        return optionValue;
    }

    option(name) {
        const options = this.options;
        const optionValue = options[name];
        return optionValue;
    }
}

export default Selection;